module.exports = __webpack_public_path__ + "static/media/account_info_1.e49e2880.png";